import get from 'lodash/get'

export function present(value) {
  return !value || !value.match(/\S/)
}

export function email(value) {
  return value && !value.match(/.*@.*\..+/)
}

export function number(value) {
  return value && value.match(/\D/)
}

export function length(amount) {
  return value => value && value.length < amount
}

export function matchesField(fieldName) {
  return (value, data) => {
    const otherValue = get(data, fieldName)
    return otherValue && otherValue !== value
  }
}



// WEBPACK FOOTER //
// client/components/util/Form/validators.js